<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          style="margin-top: 6px;"
          v-on="on"
          :loading="loading"
          :disabled="loading"
          outline
          color="grey"
        >
          <v-icon>fa fa-print</v-icon>
          &nbsp;{{ $t('parcel_number_management') }}
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-list v-if="!loading">
        <v-list-tile @click="exportTrackingOrder">
          <v-list-tile-title>
            <i class="fas fa-clipboard-list mr-2"></i
            >{{ $t('Export Order No.') }}</v-list-tile-title
          >
        </v-list-tile>
        <v-list-tile @click="onClickUploadButton">
          <span class="upload">
            <label>
              <i class="fas fa-truck"></i>
              &nbsp;Import Tracking No.
            </label>
          </span>
          <input
            type="file"
            id="importFile"
            @change="handleImportFile($event)"
            style="display: none;"
            ref="inputFile"
          />
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import 'dayjs/locale/th'
import XLSX from 'xlsx'
import dayjs from 'dayjs'

export default {
  data: function() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },
  props: ['filterOrders', 'filterStatus'],
  methods: {
    exportTrackingOrder() {
      this.loading = true
      let result = []
      // const statusExpect = this.filterStatus.filter(status => ['ordered', 'paid', 'shipped'].includes(status))
      // if (statusExpect.length) {
      //   const orderExpect = this.filterOrders.filter(order => statusExpect.includes(order.status))
      //   result = orderExpect
      //   // result =this.filterOrders.filter(f => f.status == 'ordered')
      //   //   this.filterStatus == 'ordered'
      //   //     ? this.filterOrders.filter(f => f.status == 'ordered')
      //   //     : this.filterStatus == 'paid'
      //   //     ? this.filterOrders.filter(f => f.status == 'paid')
      //   //     : this.filterOrders.filter(f => f.status == 'shipped')
      if (['ordered', 'paid', 'shipped'].includes(this.filterStatus)) {
        result =
          this.filterStatus == 'ordered'
            ? this.filterOrders.filter(f => f.status == 'ordered')
            : this.filterStatus == 'paid'
            ? this.filterOrders.filter(f => f.status == 'paid')
            : this.filterOrders.filter(f => f.status == 'shipped')
      } else {
        // Export only reviewing and paid
        result = this.filterOrders.filter(
          f => f.status == 'paid' || f.status == 'ordered' || f.status == 'shipped'
        )
      }

      if (result.length == 0) {
        this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
        this.loading = false
      }
      result = result.map(d => {
        let realname = d.nameaddress ? d.nameaddress.split(' , ') : []
        return {
          orderNumber: d.id,
          'Address Name': realname.length > 1 ? realname[0] : '',
          trackingNo: d.trackingno,
          createDate: dayjs(d.timestamp).format('DD/MM/YYYY'),
          note: ''
        }
      })
      let hasTrackingResult = result.filter(f => f.trackingNo != '' || f.trackingNo != null)
      if (hasTrackingResult.length > 0) {
        hasTrackingResult.forEach(d => {
          if (d.trackingNo) {
            let remarkIndex = d.trackingNo.indexOf('หมายเหตุ')
            let trackingno = ''
            let remark = ''
            if (remarkIndex != -1) {
              trackingno = d.trackingNo.substring(0, remarkIndex)
              remark = d.trackingNo.substring(remarkIndex)
              remark = remark.substring(10)
            }
            result.find(
              f => f.orderNumber && f.orderNumber == d.orderNumber
            ).trackingNo = trackingno
            result.find(f => f.orderNumber == d.orderNumber).note = remark
          }
        })
        this.loading = false
      }

      let dataWs = XLSX.utils.json_to_sheet(result)
      dataWs.A1.v = 'Order Number'
      dataWs.B1.v = 'Address Name'
      dataWs.C1.v = 'Tracking No.'
      dataWs.D1.v = 'Create Date'
      dataWs.E1.v = 'Note'
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWs)
      let exportDay = dayjs().format('DD/MM/YYYY')
      XLSX.writeFile(wb, 'Export Order No. ' + exportDay.toString() + '.xlsx')
    },

    onClickUploadButton() {
      document.getElementById('importFile').click()
    },

    async handleImportFile(event) {
      if (
        typeof event.target.files === 'undefined' ||
        typeof event.target.files[0] === 'undefined'
      ) {
        return
      }

      //check file size
      const file_size = 26214400
      if (event.target.files[0].size > file_size) {
        this.$swal.fire(this.$t('Error'), this.$t('file_uploads_are_limited_25_mb'), 'warning')
        return
      }
      //check file type
      const file_type = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      if (!file_type.includes(event.target.files[0].type)) {
        this.$swal.fire(this.$t('Error'), this.$t('file_upload_is_supported_only_xlsx'), 'warning')
        return
      }
      const file = event.target.files[0]
      const inputFile = this.$refs.inputFile
      let data = await this.ExcelToJson(file)
      // check data record
      if (data.length > 5000) {
        this.$swal.fire(
          this.$t('Error'),
          this.$t('the_number_of_items_must_not_exceed_5000'),
          'warning'
        )
        if (inputFile) {
          inputFile.value = null
        }
        return
      }

      if (data) {
        data = data.map(d => {
          return {
            id: d['Order Number'],
            trackNo: d['Tracking No.'] || '',
            note: d['Note']
          }
        })
        let payload = {
          pageid: this.selectedBot.pageid,
          orders: data
        }
        await this.importTrackingOrder(payload)
      } else {
        this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
      }
    },

    async importTrackingOrder(payload) {
      this.$store.dispatch('loading')
      var result = await api.saveOrdersTracking(payload)
      if (result && result.success == true) {
        this.$swal
          .fire({
            title: this.$t('Successfully'),
            text: this.$t('successfully_updated_and_notified_tracking'),
            type: 'success',
            confirmButtonText: 'ตกลง',
            allowOutsideClick: false
          })
          .then(result => {
            if (result.value) {
              this.$emit('onRefresh')
            }
          })
      } else {
        this.$swal.fire('ข้อผิดพลาด', 'ไฟล์ XLSX ไม่ถูกต้องไม่สามารถดำเนินการได้', 'warning')
      }
      this.$store.dispatch('loading')
    },

    async ExcelToJson(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = e => {
          var data = e.target.result
          var workbook = XLSX.read(data, {
            type: 'binary'
          })
          workbook.SheetNames.forEach(sheetName => {
            // Here is your object
            var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
            var json_object = JSON.stringify(XL_row_object)
            resolve(JSON.parse(json_object))
          })
        }

        reader.onerror = function(ex) {
          console.log(ex)
        }
        reader.readAsBinaryString(file)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ManageOrderno.vue